import { Pipe, PipeTransform } from '@angular/core';
import { AccuracyStatus } from '@vendasta/listing-products';

@Pipe({
  name: 'accuracyText',
  standalone: false,
})
export class AccuracyTextPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: unknown, ...args: unknown[]): unknown {
    const notFound = 'Not found';
    switch (value) {
      case AccuracyStatus.ACCURACY_STATUS_UNKNOWN:
        return notFound;
      case AccuracyStatus.ACCURACY_STATUS_UNAVAILABLE:
        return 'Source does not have reporting';
      case AccuracyStatus.ACCURACY_STATUS_ACCURATE:
        return 'Accurate';
      case AccuracyStatus.ACCURACY_STATUS_INACCURATE:
        return `Possible errors`;
    }
    return null;
  }
}

export interface AccuracyText {
  Card: string;
  Table: string;
  Sidebar: string;
}

export const ListingAccuracyText: Record<AccuracyStatus, AccuracyText> = {
  [AccuracyStatus.ACCURACY_STATUS_INVALID]: {
    Card: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.LISTING_NOT_FOUND',
    Table: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NOT_FOUND',
    Sidebar: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NOT_FOUND',
  },
  [AccuracyStatus.ACCURACY_STATUS_UNKNOWN]: {
    Card: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.LISTING_NOT_FOUND',
    Table: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NOT_FOUND',
    Sidebar: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NOT_FOUND',
  },
  [AccuracyStatus.ACCURACY_STATUS_UNAVAILABLE]: {
    Card: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NO_REPORTING',
    Table: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NO_REPORTING',
    Sidebar: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NO_REPORTING',
  },
  [AccuracyStatus.ACCURACY_STATUS_ACCURATE]: {
    Card: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.ACCURATE',
    Table: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.ACCURATE',
    Sidebar: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.ACCURATE_LISTING',
  },
  [AccuracyStatus.ACCURACY_STATUS_INACCURATE]: {
    Card: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.FOUND_WITH_ERRORS',
    Table: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.POSSIBLE_ERRORS',
    Sidebar: 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.FOUND_WITH_ERRORS',
  },
};
